import { Box } from "@mui/material"
import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"
import { BIG_ZERO } from "src/constants/bigNumber"
import { AppDispatch, AppState } from "src/state"
import {
  Slippages,
  updateSlippageCustom,
  updateSlippageSelected,
} from "src/state/user"
import AmountInput from "./AmountInput"
import Modal from "./Modal"
import Text from "./Text"
import ToggleOptions from "./ToggleOptions"
import { useIsMobile } from "../hooks/useIsMobile"
import Button from "./Button"

interface Props {
  onClose: () => void
}

const options = [
  { label: "0.5%", value: Slippages.OneHalf },
  { label: "1.0%", value: Slippages.One },
  { label: "1.5%", value: Slippages.OneAndAHalf },
  { label: "2.0%", value: Slippages.Two },
]

export default function SlippageSettingModal({ onClose }: Props) {
  const { t } = useTranslation()
  const dispatch = useDispatch<AppDispatch>()
  const {
    slippageCustom: storeSlippageCustom,
    slippageSelected: storeSlippageSelected,
  } = useSelector((state: AppState) => state.user)

  const [slippageCustom, setSlippageCustom] = useState(
    storeSlippageCustom?.valueRaw,
  )
  const [slippageSelected, setSlippageSelected] = useState(
    storeSlippageSelected,
  )
  const isMobile = useIsMobile()

  const onConfirm = () => {
    dispatch(updateSlippageSelected(slippageSelected))
    dispatch(updateSlippageCustom(slippageCustom || ""))
    onClose()
  }

  return (
    <Modal title={t("Slippage Tolerance")} open onClose={onClose}>
      <Box minWidth={isMobile ? 200 : 300}>
        <Text mb={0.5}>{t("Custom Slippage (%)")}</Text>
        <AmountInput
          value={slippageCustom || ""}
          decimals={1}
          balance={BIG_ZERO}
          onChange={(value) => {
            if (value && !isNaN(+value)) {
              setSlippageCustom(value)
              // dispatch(updateSlippageCustom(value))
              setSlippageSelected(Slippages.Custom)
              // dispatch(updateSlippageSelected(Slippages.Custom))
            } else {
              setSlippageCustom("")
              setSlippageSelected(Slippages.One)
              // dispatch(updateSlippageSelected(Slippages.One))
            }
          }}
          hideBalance
          hidePercentageButtons
          suffix="%"
          maxWholeDigit={2}
        />
        <Box my={2}>
          <ToggleOptions
            options={options}
            value={slippageSelected}
            onChange={(value) => {
              setSlippageCustom("")
              setSlippageSelected(value)
            }}
          />
        </Box>
        <Button fullWidth onClick={onConfirm}>
          {t("Confirm")}
        </Button>
      </Box>
    </Modal>
  )
}
